@if (entirePageLoad) {
  <div class="quick-top-header-title mx-sm-3 mob_padd">
    <h1 class="col-12 col-md-12 col-lg-4 quick-order-title m-0">
    {{'common.text_quickOrder_header'|cxTranslate}}</h1>
    <div class="col-12 col-md-12 col-lg-8 buttonsQuickOrder">
      <div class="buttonContainer">
        <button class="btn btn-block button-launch"
        (click)="resetForm()">{{'common.text_quick_order_reset_form'|cxTranslate}}</button>
      </div>
      <div class="buttonContainer">
        <button class="btn btn-primary btn-block btn-cart" [disabled]="disableAddToCart()"
          (click)="PostAllData()">
          <span class="fa fa-shopping-cart cart-icon"></span>
          {{'common.pdp_page_add_to_cart'|cxTranslate}}
          <img src="/icons/link-grey.svg" class="icon-right" alt=""></button>
        </div>
      </div>
    </div>
    <div class="row order-section mt-2 mx-sm-3 ps-2 cart-order-section mob_padd">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5">
        <div class="row import-order-type-select">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="row">
              <label class="col-sm-12 col-md-12 col-lg-4 order-type f-20 c-black">
              {{'common.text_quickOrder_order_type'|cxTranslate}}</label>
              <div class=" col-sm-12 col-md-12 col-lg-8 order-type-select">
                <select class="form-select" id="cart-order-type" #dropdown
                  [ngClass]="orderTypeNotSelected ? 'errInvalid' : ''"
                  (change)="onDropdownChange(dropdown.value)">
                  <option [selected]="!orderTypeSelected" value="null" disabled>
                  {{'common.cart_orderType_selection'|cxTranslate}}</option>
                  @for (item of entry; track item) {
                    <option [value]="item.key"
                      [selected]='item.key == orderType'>
                      {{item.value}}
                    </option>
                  }
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-7">
        <div class="row deliveryDate">
          <label for="deliveryDate" class="col-xs-12 col-sm-12 col-md-7 text-md-end text-start text-end">
          {{'common.quick_order_page_req_delivery_date_for_all_items'|cxTranslate}}</label>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5 cart-top-date-div">
            <form [formGroup]="topDateForm">
              <input class="form-control bsdpicker kb-datePickerIcon" bsDatepicker [(ngModel)]="toClearDate"
                [disabled]="isOrderTypeVORDisableDates" (bsValueChange)="onDateChange($event)"
                [minDate]="bsDate" formControlName="topdate" (keyup)="assignLastDate($event)"
                (change)="isInvalidDate($event)"
                [bsConfig]="{ dateInputFormat:dateFormat,showWeekNumbers:false, displayOneMonthRange: true }"
                [daysDisabled]="[6,0]">
                @if (isPastDate) {
                  <span class="quickOrderErrorText"
                  >{{'common.globle_notLessThanToday'|cxTranslate}}</span>
                }
                @if (isWeekendDate && !isPastDate) {
                  <span class="quickOrderErrorText"
                  >{{'common.globle_weekendDate'|cxTranslate}}</span>
                }
                @if (invalidDate) {
                  <span class="quickOrderErrorText"
                  >{{'common.globle_invalidDateFormat'|cxTranslate}}</span>
                }
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="row cart-list-item-wrapper mt-lg-0 mx-sm-3 mob_padd">
        <div class="col-12 mobile-delete-wrapper" [ngClass]="datesRevised ?'d-flex align-items-center':'text-end'">
          @if (datesRevised) {
            <div class="col-3"></div>
            <div class="dateRevision col-6">
              {{'common.quick_order_page_alert_order_type_change'|cxTranslate}}
            </div>
            <div class="col-1"></div>
          }
          <button class="cart-delete-selected " [ngClass]="datesRevised ? 'col-2' : 'text-end'"
          (click)="removeSelectedRows()">{{'common.text_quickOrder_delete_checkboxes'|cxTranslate}}</button>
          <div class="d-lg-none col-2 col-md-1 delete-checkbox-section">
            <span class="custom-checkbox">
              <input id="remove_cart-all-mobile" name="removecartmobile" class="cart-checkbox" type="checkbox"
                (change)="selectAllCheckboxes($event)" [(ngModel)]="isselectAllcheckBoxes">
                <label for="remove_cart-all"></label>
              </span>
            </div>
          </div>
          <div class="col-12 mt-0 p-0 cart-details-section">
            <div class="table-responsive">
              <table class="table table-bordered ">
                <thead>
                  <tr class="d-none d-lg-table-row">
                    <td class="code-header">{{'common.text_quickOrder_page_na_part_no'|cxTranslate}}</td>
                    <td class="header-description">{{'common.text_account_savedCart_description'|cxTranslate}}
                    </td>
                    <td class="header-qty">{{'common.text_quickOrder_page_qty'|cxTranslate}}</td>
                    <td class="header-reqdeliveryDate">
                      {{'common.quick_order_req'|cxTranslate}}<br>{{'common.cart_page_deliverydate'|cxTranslate}}
                    </td>
                    <td class="select-all-check">
                      <span class="custom-checkbox">
                        <input id="remove_cart-all" name="removecart" class="cart-checkbox" type="checkbox"
                          (change)="selectAllCheckboxes($event)" [(ngModel)]="isselectAllcheckBoxes">
                          <label for="remove_cart-all"></label>
                        </span>
                      </td>
                    </tr>
                  </thead>
                  <tbody class="table-content w-100">
                    <ng-container [formGroup]="myForm">
                      <ng-container formArrayName="formArray">
                        @for (row of getFormArrayControls(); track row; let i = $index) {
                          <ng-container
                            [formGroupName]="i">
                            <tr class="cart-for-mobile">
                              <td class="product-code">
                                <input type="text" (blur)="checkPartNumberValidity(i)"
                                  (keydown.enter)="checkPartNumberValidity(i)"
                                  (click)="addNewRowIfLastRowClicked(i)"
                                  (input)="addNewRowIfLastRowClicked(i)"
                                  [ngClass]="row.get('partNumber').hasError('partNumberInvalid') ? 'errInvalid':''"
                                  formControlName="partNumber"
                                  placeholder="{{'common.text_enter_partnumber_placeholder'|cxTranslate}}"
                                  class="form-control text-center border cart-quantity-input">
                                  @if (row.get('partNumber').hasError('partNumberInvalid')) {
                                    <span
                                      class="quickOrderErrorText">
                                      {{getProdInfo?.message|cxTranslate}}
                                    </span>
                                  }
                                </td>
                                <td class="part-no">
                                  @if (getFormArrayControls()[i]?.get('desc')?.value !== null) {
                                    <div class="quickdescription"
                                      >
                                      {{ getFormArrayControls()[i]?.get('desc')?.value }}
                                    </div>
                                  }
                                </td>
                                <td class="qty">
                                  <div>
                                    <span class="d-lg-none">{{'common.basket_page_qty'|cxTranslate}}</span>
                                    <span class="qty_input">
                                      <input type="number" formControlName="qty" min="0"
                                        [ngClass]="(getFormArrayControls()[i]?.get('qty')?.invalid)&&(getFormArrayControls()[i]?.get('qty')?.touched) ? 'errInvalid':''"
                                        class="form-control text-center border cart-quantity-input">
                                      </span>
                                    </div>
                                  </td>
                                  <td class="rdd">
                                    <div class="item_delivery-datepicker quick-order-datepicker">
                                      <span
                                        class="d-lg-none w-50">{{'common.text_quickOrder_requested'|cxTranslate}}<br>{{'common.text_quickOrder_delivery_date'|cxTranslate}}</span>
                                        <input class="form-control bsdpicker kb-datePickerIcon" bsDatepicker
                                          formControlName="date" [class.disabler]="isOrderTypeVORDisableDates"
                                          [(ngModel)]="selectedDates[i]" [minDate]="bsDate"
                                          (bsValueChange)="onBotDateChange($event,i)"
                                          (change)="isInvalidDateBot($event,i)"
                                          (keyup)="assignLastDateBot($event,i)"
                                          (click)="this.maxCallStackBugPatchFix = true"
                                          [bsConfig]="{ dateInputFormat: dateFormat,showWeekNumbers:false, displayOneMonthRange: true }"
                                          [daysDisabled]="[6,0]">
                                          @if (isPastDatebot[i]) {
                                            <span class="quickOrderErrorText"
                                            >{{'common.globle_notLessThanToday'|cxTranslate}}</span>
                                          }
                                          @if (isWeekendDatebot[i] && !isPastDatebot[i]) {
                                            <span class="quickOrderErrorText"
                                            >{{'common.globle_weekendDate'|cxTranslate}}</span>
                                          }
                                          @if (invalidDatebot[i]) {
                                            <span class="quickOrderErrorText"
                                            >{{'common.globle_invalidDateFormat'|cxTranslate}}</span>
                                          }
                                        </div>
                                      </td>
                                      <td class="remove-checkbox">
                                        <div class="d-flex align-items-center remove-mobile">
                                          <span class="custom-checkbox me-3">
                                            <mat-checkbox formControlName="checkbox"></mat-checkbox>
                                          </span>
                                          <span class="remove-item" (click)="removeField(i)"></span>
                                        </div>
                                      </td>
                                    </tr>
                                  </ng-container>
                                }
                              </ng-container>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="d-flex col-12 px-0 quick-order-buttons-block">
                      @if (!isMobile) {
                        <div class="d-none d-lg-block col-lg-4"></div>
                      }
                      <div class=" buttonsQuickOrder px-0" [ngClass]="isMobile ? 'col-12 col-lg-8': 'col-12 col-md-12 col-lg-8'">
                        <div class="buttonContainer">
                          <button class="btn btn-block button-launch"
                          (click)="resetForm()">{{'common.text_quick_order_reset_form'|cxTranslate}}</button>
                        </div>
                        <div class="buttonContainer">
                          <button class="btn btn-primary btn-block btn-cart" [disabled]="disableAddToCart()"
                            (click)="PostAllData()">
                            <span class="fa fa-shopping-cart cart-icon"></span>
                            {{'common.pdp_page_add_to_cart'|cxTranslate}}
                            <img src="/icons/link-grey.svg" class="icon-right" alt="">
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                }